import { createStore, applyMiddleware, compose }    from 'redux';
import { combineReducers }                          from 'immutable-reducers';
import thunk                                        from 'redux-thunk';
import { Map, fromJS }                              from 'immutable';
import browserStore                                 from 'store';
import { syncHistory }                              from 'redux-simple-router';

import { browserHistory }           from 'app/lib/browserHistory';
import { sagaMiddleware }           from 'modules/sagas';
import { settings }                 from 'app/globals';
import { userRoles, accessLevels }  from 'app/access';
// import loggerMiddleware             from 'app/middleware/logger';
import promiseMiddleware            from 'app/middleware/promise';
import reqresMiddleware             from 'app/middleware/reqres';
import rootReducer                  from 'modules/rootReducer';


const currentLocale = function () {
    let locale = browserStore.get('locale');
    if (settings.supportedLocales.indexOf(locale) !== -1) {
        return locale;
    }

    locale = navigator.language || navigator.browserLanguage;

    if (settings.supportedLocales.indexOf(locale) !== -1) {
        return locale;
    }

    return settings.defaultLocale;
};

//-------------------------------------------------
//          Store middleware
//-------------------------------------------------
const reduxRouterMiddleware = syncHistory(browserHistory);

let middleware = [reduxRouterMiddleware,thunk,promiseMiddleware,reqresMiddleware,sagaMiddleware];

if (process.env.NODE_ENV === 'development') {
    //middleware.push(loggerMiddleware);
}


//-------------------------------------------------
//          Store initial state
//-------------------------------------------------

/**
 * @PointOfInterest("Global State")
 */
let state = fromJS({
    // TODO
    accessLvl: {},
    // TODO
    auth: {},
    // Contains the data for the current form
    form: {},
    // A list of all license plates for the logged in user
    licensePlates: [],
    // Profile data of the logged in user
    profile: {licensePlate:'', companyName:'', terminals: [], rights: [], locale: currentLocale(), firstName:'', lastName:'',requestingCompany:''},
    // A list of the announced visits
    visits: {},
    // Contains information about the current route
    route: {},
    // Contains temporary data for the current user session
    session: {},
    // Contains time slot info for the selected visit day
    timeSlots: {}
});

const initialState = state.set('auth', {isAuthenticating: false, accessLvl: userRoles.public});


//-------------------------------------------------
//          Create the Store
//-------------------------------------------------

const finalCreateStore = compose(
    applyMiddleware(
        ...middleware
    ),
    process.env.NODE_ENV === 'development' && window.devToolsExtension ? window.devToolsExtension() : f => f
)(createStore);

if (process.env.NODE_ENV === 'development' && module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../../modules/rootReducer', () => {
        const nextRootReducer = require('../../modules/rootReducer');
        store.replaceReducer(nextRootReducer);
    });
}

export const store = finalCreateStore(rootReducer, initialState);

//-------------------------------------------------
//          Additional Store methods
//-------------------------------------------------

export function isAuthorized(state) {
    return state.get('auth').accessLvl.bitMask !== accessLevels.anon.bitMask;
}
